(function () {
  "use strict";

  var loader = Array.from(document.querySelectorAll(
    'script[src*="wgc-lpo-overrides.js"]'
  )).find(function (script) {
    return script.hasAttribute("data-allow-design-customizations") &&
      script.hasAttribute("data-show-upload");
  }) || document.currentScript;
  var config = window.WGCLpoConfig || {};

  if (window.__wgcLpoOverridesLoaded) return;
  window.__wgcLpoOverridesLoaded = true;

  var allowDesignCustomizations =
    config.allowDesignCustomizations === true ||
    (!!loader && loader.dataset.allowDesignCustomizations === "true");
  var showUpload = config.showUpload === true ||
    (!!loader && loader.dataset.showUpload === "true");
  var moveUploadBeforeCustomizations =
    config.moveUploadBeforeCustomizations === true ||
    (!!loader && loader.dataset.moveUploadBeforeCustomizations === "true");
  var isIndividualProduct =
    config.individualProduct === true ||
    (!!loader && loader.dataset.individualProduct === "true");
  var hasDiscountPricing =
    config.discountPricing === true ||
    (!!loader && loader.dataset.discountPricing === "true");

  var FONT_SELECT_SELECTOR =
    '.cl-po--font-selector select.cl-po--input[name$="_font"]';
  var VARIANT_SELECT_SELECTOR =
    ".cl-po--option select.cl-po--input[name^='v_']";
  var VARIANT_BUTTON_LABELS = [
    "Choose a Size",
    "Cookie Shape",
    "Size",
    "Gift Size"
  ];
  var HIDDEN_CART_PROPERTY_NAMES = [
    "Quantity Surcharge",
    "QuantitySurcharge",
    "Cookie Shape"
  ];
  var variantGroupCounter = 0;
  var defaultVariantId = String(
    config.defaultVariantId ||
    (loader && loader.dataset.shopifyDefaultVariant) ||
    ""
  );
  var shopifyVariantPrices = config.variantPrices || {};
  var shopifyVariantTitles = config.variantTitles || {};
  var customerQuantityChoice = null;

  if (loader && loader.dataset.shopifyVariantPrices) {
    loader.dataset.shopifyVariantPrices.split(",").forEach(function (entry) {
      var parts = entry.split(":");
      if (parts.length === 2) {
        shopifyVariantPrices[String(parts[0])] = Number(parts[1]);
      }
    });
  }

  function normalize(value) {
    return (value || "").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function parsePrice(value) {
    var text = (value || "").replace(/,/g, "").trim();
    var match = text.match(/-?\s*[$£€]?[\s]*\d+(?:\.\d+)?/);
    if (!match) return NaN;

    var amountMatch = match[0].match(/\d+(?:\.\d+)?/);
    if (!amountMatch) return NaN;

    var amount = parseFloat(amountMatch[0]);
    return match[0].indexOf("-") !== -1 ? -amount : amount;
  }

  function getCurrencyPrefix(value) {
    var text = (value || "").trim();
    var amountMatch = text.replace(/,/g, "").match(/\d+(?:\.\d+)?/);
    if (!amountMatch) return "$";

    var position = text.indexOf(amountMatch[0]);
    var prefix = position > -1 ? text.slice(0, position).replace(/[-\s]/g, "") : "";
    return prefix || "$";
  }

  function getShopifyBasePrice(productInfo) {
    var variantId = getSelectedVariantId(productInfo);
    var cents = Number(shopifyVariantPrices[variantId]);

    return Number.isFinite(cents)
      ? "$" + (cents / 100).toFixed(2) + " Each"
      : "";
  }

  function normalizeVariantChoice(value) {
    return normalize(String(value || ""))
      .replace(/\s+-\s+[$£€].*$/, "")
      .replace(/\s*\/\s*/g, " / ");
  }

  function getSelectedVariantId(productInfo) {
    if (!productInfo) return defaultVariantId;

    /* Read only actual Shopify/LPO variant selectors. Add-on inputs can change
     * LPO's internal product ID, so that ID must never drive the base price. */
    var selectedChoices = [];
    var selectedVariantIds = [];
    productInfo.querySelectorAll(
      VARIANT_SELECT_SELECTOR + ", variant-selects select, " +
      "select[name^='options[']"
    ).forEach(function (select) {
      if (select.selectedIndex < 0) return;
      var option = select.options[select.selectedIndex];
      if (!option) return;
      selectedChoices.push(option.textContent || "");
      selectedChoices.push(option.value || "");
      selectedVariantIds.push(option.getAttribute("data-variant-id") || "");
      selectedVariantIds.push(option.value || "");
    });
    productInfo.querySelectorAll(
      "variant-radios .product-form__input input[type='radio']:checked, " +
      "variant-selects .product-form__input input[type='radio']:checked, " +
      "input[name^='options['][type='radio']:checked"
    ).forEach(function (input) {
      var label = input.closest("label");
      selectedChoices.push((label && label.textContent) || input.value || "");
    });

    var selectedOptionId = selectedVariantIds.find(function (id) {
      return Object.prototype.hasOwnProperty.call(
        shopifyVariantPrices,
        String(id)
      );
    });
    if (selectedOptionId) return String(selectedOptionId);

    var normalizedChoices = selectedChoices.map(normalizeVariantChoice).filter(Boolean);
    var visibleVariantId = Object.keys(shopifyVariantTitles).find(function (id) {
      var title = normalizeVariantChoice(shopifyVariantTitles[id]);
      var titleParts = title.split(" / ");
      return normalizedChoices.indexOf(title) !== -1 ||
        (titleParts.length > 1 && titleParts.every(function (part) {
          return normalizedChoices.indexOf(part) !== -1;
        }));
    });
    if (!visibleVariantId) {
      visibleVariantId = Object.keys(shopifyVariantTitles).find(function (id) {
        var titleParts = normalizeVariantChoice(shopifyVariantTitles[id])
          .split(" / ");
        return normalizedChoices.some(function (choice) {
          return titleParts.indexOf(choice) !== -1;
        });
      });
    }
    if (visibleVariantId) return visibleVariantId;

    var mainVariantInput = productInfo.querySelector(
      'form[id^="product-form-"] input.product-variant-id[name="id"], ' +
      'form[id^="product-form-"] > input[name="id"]'
    );
    var selectedId = mainVariantInput
      ? String(mainVariantInput.value || "")
      : "";

    return Object.prototype.hasOwnProperty.call(shopifyVariantTitles, selectedId)
      ? selectedId
      : defaultVariantId;
  }

  function isMinimumExemptVariant(productInfo) {
    var title = String(
      shopifyVariantTitles[getSelectedVariantId(productInfo)] || ""
    ).toLowerCase().replace(/\s+/g, "").replace(/×/g, "x");
    if (title.indexOf("8x10") !== -1) return true;

    /* Fallback for LPO-controlled Shopify variants: some LPO configurations
     * update the visible selector before Shopify's hidden variant ID changes. */
    var selectedTexts = [];
    productInfo.querySelectorAll("select").forEach(function (select) {
      if (select.selectedIndex < 0) return;
      var option = select.options[select.selectedIndex];
      if (option) selectedTexts.push(option.textContent || option.value || "");
    });
    productInfo.querySelectorAll(
      'input[type="radio"]:checked, input[type="checkbox"]:checked'
    ).forEach(function (input) {
      var label = input.closest("label");
      selectedTexts.push(
        (label && label.textContent) || input.value || ""
      );
    });

    return selectedTexts.some(function (text) {
      return String(text).toLowerCase()
        .replace(/\s+/g, "")
        .replace(/×/g, "x")
        .indexOf("8x10") !== -1;
    });
  }

  function updateMinimumQuantityExemption() {
    document.querySelectorAll(
      ".product__info-container, product-info, .product__info-wrapper"
    ).forEach(function (productInfo) {
      var enforceMinimum = isIndividualProduct || !!productInfo.querySelector(
        '.cl-po--option[data-option="Price Calculator"], .wgc-volume-pricing'
      );
      var exempt = enforceMinimum && isMinimumExemptVariant(productInfo);
      var quantityInput = productInfo.querySelector(
        "input[name='quantity'], input.quantity__input, [data-quantity-input]"
      );

      if (quantityInput) {
        if (!Object.prototype.hasOwnProperty.call(
          quantityInput.dataset,
          "wgcOriginalMin"
        )) {
          quantityInput.dataset.wgcOriginalMin = quantityInput.hasAttribute("min")
            ? quantityInput.getAttribute("min")
            : "__missing__";
          quantityInput.dataset.wgcOriginalDataMin = quantityInput.hasAttribute("data-min")
            ? quantityInput.getAttribute("data-min")
            : "__missing__";
        }

        if (enforceMinimum) {
          var minimumQuantity = exempt ? 2 : 12;
          quantityInput.setAttribute("min", String(minimumQuantity));
          if (quantityInput.hasAttribute("data-min")) {
            quantityInput.setAttribute("data-min", String(minimumQuantity));
          }
          quantityInput.required = true;

          /* Shopify/LPO can refill the input with its minimum when a size
           * changes. Keep it empty until the shopper chooses a quantity;
           * preserve their choice only if it is valid for the new size. */
          if (document.activeElement !== quantityInput) {
            var chosenQuantity = customerQuantityChoice === null
              ? NaN
              : Number(customerQuantityChoice);
            var desiredQuantity = Number.isInteger(chosenQuantity) &&
              chosenQuantity >= minimumQuantity
              ? String(chosenQuantity)
              : "";
            if (quantityInput.value !== desiredQuantity) {
              quantityInput.value = desiredQuantity;
            }
          }
        } else {
          if (quantityInput.dataset.wgcOriginalMin === "__missing__") {
            quantityInput.removeAttribute("min");
          } else {
            quantityInput.setAttribute("min", quantityInput.dataset.wgcOriginalMin);
          }
          if (quantityInput.dataset.wgcOriginalDataMin === "__missing__") {
            quantityInput.removeAttribute("data-min");
          } else {
            quantityInput.setAttribute(
              "data-min",
              quantityInput.dataset.wgcOriginalDataMin
            );
          }
        }
      }

      productInfo.querySelectorAll(
        'input[name="_Minimum"], input[name*="[_Minimum]"], ' +
        '.cl-po--option[data-option="Minimum"] input'
      ).forEach(function (input) {
        if (!input.dataset.wgcOriginalDisabled) {
          input.dataset.wgcOriginalDisabled = input.disabled ? "true" : "false";
          input.dataset.wgcOriginalRequired = input.required ? "true" : "false";
        }

        if (exempt) {
          input.disabled = true;
          input.required = false;
        } else {
          input.disabled = input.dataset.wgcOriginalDisabled === "true";
          input.required = input.dataset.wgcOriginalRequired === "true";
        }
      });

      productInfo.classList.toggle("wgc-minimum-exempt-variant", exempt);
    });
  }

  function sameOrder(current, desired) {
    return current.length === desired.length && current.every(function (node, index) {
      return node === desired[index];
    });
  }

  function sortNativeSelect(select) {
    var selected = select.value;
    var current = Array.from(select.options || []);
    if (current.length < 2) return;

    var pinned = current.filter(function (option) {
      return option.value === "" || option.disabled;
    });
    var sortable = current.filter(function (option) {
      return option.value !== "" && !option.disabled;
    });

    sortable.sort(function (a, b) {
      return (a.textContent || a.value || "").trim().localeCompare(
        (b.textContent || b.value || "").trim(),
        undefined,
        { sensitivity: "base", numeric: true }
      );
    });

    var desired = pinned.concat(sortable);
    if (!sameOrder(current, desired)) {
      desired.forEach(function (option) {
        select.appendChild(option);
      });
    }

    if (Array.from(select.options).some(function (option) {
      return option.value === selected;
    })) {
      select.value = selected;
    }
  }

  function sortChoicesDropdown(select) {
    var choices = select.closest(".choices");
    if (!choices) return;

    var list = choices.querySelector(".choices__list--dropdown .choices__list");
    if (!list) return;

    var current = Array.from(list.children).filter(function (item) {
      return item.classList.contains("choices__item--choice");
    });
    if (current.length < 2) return;

    var pinned = current.filter(function (item) {
      return !(item.getAttribute("data-value") || "").trim() ||
        item.classList.contains("cl-po--placeholder");
    });
    var sortable = current.filter(function (item) {
      return (item.getAttribute("data-value") || "").trim() &&
        !item.classList.contains("cl-po--placeholder");
    });

    sortable.sort(function (a, b) {
      return (a.getAttribute("data-value") || "").trim().localeCompare(
        (b.getAttribute("data-value") || "").trim(),
        undefined,
        { sensitivity: "base", numeric: true }
      );
    });

    var desired = pinned.concat(sortable);
    if (!sameOrder(current, desired)) {
      desired.forEach(function (item) {
        list.appendChild(item);
      });
    }
  }

  function sortFonts() {
    document.querySelectorAll(FONT_SELECT_SELECTOR).forEach(function (select) {
      sortNativeSelect(select);
      sortChoicesDropdown(select);
    });
  }

  function getVariantContainer(select) {
    if (!select.parentElement) return null;
    return Array.from(
      select.parentElement.querySelectorAll(".lpo-variant-override")
    ).find(function (container) {
      return container.__wgcSourceSelect === select;
    }) || null;
  }

  function syncVariantButtons(select) {
    var container = getVariantContainer(select);
    if (!container) return;

    container.querySelectorAll("input[type='radio']").forEach(function (radio) {
      radio.checked = radio.value === select.value;
      var swatch = radio.nextElementSibling;
      if (swatch) swatch.classList.toggle("is-selected", radio.checked);
    });
  }

  function variantSignature(options) {
    return options.map(function (option) {
      return [option.value, option.textContent, option.disabled].join("::");
    }).join("||");
  }

  function shouldConvertVariantSelect(select) {
    if (!select.name || select.name.indexOf("v_") !== 0) return false;
    var field = select.closest(".cl-po--option");
    var name = field ? (field.getAttribute("data-option") || "").trim() : "";
    return !VARIANT_BUTTON_LABELS.length || VARIANT_BUTTON_LABELS.indexOf(name) !== -1;
  }

  function buildVariantButtons(select) {
    if (!shouldConvertVariantSelect(select)) return;

    var options = Array.from(select.options).filter(function (option) {
      return option.value !== "";
    });
    if (!options.length) return;

    var signature = variantSignature(options);
    var existing = getVariantContainer(select);
    if (existing && select.dataset.lpoButtonSignature === signature) {
      syncVariantButtons(select);
      return;
    }
    if (existing) existing.remove();

    var container = document.createElement("div");
    container.className = "cl-po--swatch-container lpo-variant-override";
    container.__wgcSourceSelect = select;

    variantGroupCounter += 1;
    var groupName = "wgc-lpo-variant-" + variantGroupCounter;

    options.forEach(function (option) {
      var label = document.createElement("label");
      label.className = "cl-po--swatch-item";

      var radio = document.createElement("input");
      radio.type = "radio";
      radio.className = "cl-po--input";
      radio.name = groupName;
      radio.value = option.value;
      radio.required = select.required;
      radio.disabled = option.disabled;
      radio.checked = select.value === option.value;

      var button = document.createElement("div");
      button.className = "cl-po--swatch cl-po--swatch-button cl-po--small";
      button.textContent = (option.textContent || "").trim();

      radio.addEventListener("change", function () {
        if (!radio.checked || select.value === option.value) return;
        select.value = option.value;
        select.dispatchEvent(new Event("input", { bubbles: true }));
        select.dispatchEvent(new Event("change", { bubbles: true }));
      });

      label.appendChild(radio);
      label.appendChild(button);
      container.appendChild(label);
    });

    select.style.display = "none";
    select.setAttribute("aria-hidden", "true");
    select.insertAdjacentElement("afterend", container);
    select.dataset.lpoButtonSignature = signature;

    if (!select.__wgcSyncBound) {
      select.addEventListener("change", function () {
        syncVariantButtons(select);
      });
      select.__wgcSyncBound = true;
    }

    syncVariantButtons(select);
  }

  function updateVariantButtons() {
    document.querySelectorAll(VARIANT_SELECT_SELECTOR).forEach(buildVariantButtons);
  }

  function hideMinimumSelectors() {
    document.querySelectorAll('input[name="_Minimum"]').forEach(function (input) {
      var field = input.closest(".cl-po--option");
      if (field) field.classList.add("wgc-lpo-minimum-option");
    });

    document.querySelectorAll(
      '.cl-po--option input[type="checkbox"][value^="12-23"]'
    ).forEach(function (input) {
      var field = input.closest(".cl-po--option");
      if (field) field.classList.add("wgc-lpo-quantity-surcharge-option");
    });

    document.querySelectorAll(
      '.cl-po--option[data-option="_quantitysurcharge"]'
    ).forEach(function (field) {
      field.classList.add("wgc-lpo-quantity-surcharge-option");
    });
  }

  function styleTitleQualifiers() {
    document.querySelectorAll(".cl-po--label").forEach(function (label) {
      var field = label.closest(".cl-po--option");
      var optionName = normalize(field && field.getAttribute("data-option"));
      var title = normalize(label.textContent);
      var isAutomaticRequiredTitle =
        optionName === "final proof" ||
        optionName === "packaging" ||
        title.indexOf("final review") !== -1 ||
        title.indexOf("packaging") !== -1;

      if (isAutomaticRequiredTitle && !/\brequired\b/i.test(label.textContent || "")) {
        var existingTitle = label.querySelector(":scope > .wgc-lpo-title-text");

        if (existingTitle) {
          var automaticQualifier = document.createElement("span");
          automaticQualifier.className = "wgc-lpo-title-qualifier";
          automaticQualifier.textContent = "(required)";
          existingTitle.appendChild(document.createTextNode(" "));
          existingTitle.appendChild(automaticQualifier);
        } else {
          var directTitleText = Array.from(label.childNodes).find(function (child) {
            return child.nodeType === Node.TEXT_NODE && child.nodeValue.trim();
          });

          if (directTitleText) {
            directTitleText.nodeValue =
              directTitleText.nodeValue.replace(/\s+$/, "") + " (required) ";
          }
        }
      }

      var walker = document.createTreeWalker(
        label,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function (node) {
            if (!/\b(required|optional)\b/i.test(node.nodeValue || "")) {
              return NodeFilter.FILTER_REJECT;
            }

            var parent = node.parentElement;
            if (parent && parent.closest(
              ".wgc-lpo-title-qualifier, .cl-po--value, .cl-po--price"
            )) {
              return NodeFilter.FILTER_REJECT;
            }

            return NodeFilter.FILTER_ACCEPT;
          }
        }
      );
      var textNodes = [];
      var node;

      while ((node = walker.nextNode())) textNodes.push(node);

      textNodes.forEach(function (textNode) {
        var pieces = (textNode.nodeValue || "").split(
          /(\(\s*(?:required|optional)\s*\)|\b(?:required|optional)\b)/gi
        );
        var fragment = document.createDocumentFragment();

        pieces.forEach(function (piece) {
          var qualifierMatch = piece.match(/\b(required|optional)\b/i);

          if (qualifierMatch) {
            var qualifier = document.createElement("span");
            qualifier.className = "wgc-lpo-title-qualifier";
            qualifier.textContent = "(" + qualifierMatch[1].toLowerCase() + ")";
            fragment.appendChild(qualifier);
          } else if (piece) {
            fragment.appendChild(document.createTextNode(piece));
          }
        });

        var titleText = document.createElement("span");
        titleText.className = "wgc-lpo-title-text";
        titleText.appendChild(fragment);
        textNode.parentNode.replaceChild(titleText, textNode);
      });
    });
  }

  function compactLabelValues() {
    document.querySelectorAll(".cl-po--label").forEach(function (label) {
      var value = label.querySelector(":scope > .cl-po--value");
      var price = label.querySelector(":scope > .cl-po--price");

      if (!value || !price) return;

      var row = document.createElement("span");
      row.className = "wgc-lpo-value-price-row";
      label.insertBefore(row, value);
      row.appendChild(value);
      row.appendChild(price);
    });
  }

  function placeVolumePricingChart(productInfo, chart, priceDisplay) {
    /* The custom read-more block includes its own View more button. Anchor
     * after that whole block, not between its text and toggle. */
    var readMore = productInfo.querySelector(".custom-read-more-container");
    var nativeDescription = productInfo.querySelector(".product__description");
    var description = readMore || nativeDescription;
    if (readMore && nativeDescription && (
      nativeDescription.contains(readMore) ||
      (readMore.compareDocumentPosition(nativeDescription) &
       Node.DOCUMENT_POSITION_FOLLOWING)
    )) description = nativeDescription;
    var sizeField = Array.from(productInfo.querySelectorAll(
      ".cl-po--option[data-option], .product-form__input"
    )).find(function (field) {
      var optionName = field.getAttribute("data-option") || "";
      var heading = field.querySelector(
        ":scope > .cl-po--label, legend.form__label, label.form__label"
      );
      var name = normalize(optionName || (heading && heading.textContent));
      return /^(?:cookie size|choose a size|size|gift size)(?:\s*[:(]|$)/
        .test(name) && field.getClientRects().length > 0;
    });
    var anchor = description;
    if (sizeField && (!anchor ||
        (anchor.compareDocumentPosition(sizeField) &
         Node.DOCUMENT_POSITION_FOLLOWING))) {
      anchor = sizeField;
    }
    if (anchor) {
      if (anchor.nextElementSibling !== chart) {
        anchor.insertAdjacentElement("afterend", chart);
      }
      return;
    }

    /* Products without either field keep the chart near the title. */
    var title = productInfo.querySelector(".product__title");
    if (title) {
      if (title.nextElementSibling !== chart) {
        title.insertAdjacentElement("afterend", chart);
      }
    } else if (productInfo.querySelector(".product-form__quantity")) {
      var quantityBlock = productInfo.querySelector(".product-form__quantity");
      if (quantityBlock.previousElementSibling !== chart) {
        quantityBlock.insertAdjacentElement("beforebegin", chart);
      }
    } else if (priceDisplay.nextElementSibling !== chart) {
      priceDisplay.insertAdjacentElement("afterend", chart);
    }
  }

  function updateVolumePricingChart(
    productInfo,
    priceDisplay,
    baseText,
    selectedAddonCents
  ) {
    var basePrice = parsePrice(baseText);
    var existingCharts = Array.from(productInfo.querySelectorAll(
      '.wgc-volume-pricing:not([data-wgc-chart="purchase"])'
    ));
    var chart = existingCharts.shift() || null;

    existingCharts.forEach(function (duplicate) {
      duplicate.remove();
    });

    if (!Number.isFinite(basePrice) || basePrice < 0) {
      if (chart) chart.remove();
      return;
    }

    if (chart && chart.tagName !== "SECTION") {
      chart.remove();
      chart = null;
    }
    if (!chart) {
      chart = document.createElement("section");
      chart.className = "wgc-volume-pricing";
      chart.setAttribute("aria-label", "Volume Pricing");
    }
    chart.dataset.wgcChart = "primary";
    placeVolumePricingChart(productInfo, chart, priceDisplay);

    var currency = getCurrencyPrefix(baseText);
    var baseCents = Math.round(basePrice * 100);
    var tiers = [
      { quantity: "12–23", min: 12, max: 23, cents: baseCents + 150 },
      {
        quantity: hasDiscountPricing ? "24–99" : "24+",
        min: 24,
        max: hasDiscountPricing ? 99 : null,
        cents: baseCents,
        base: true
      }
    ];

    if (hasDiscountPricing) {
      tiers = tiers.concat([
        { quantity: "100–499", min: 100, max: 499, cents: Math.round(baseCents * 0.90) },
        { quantity: "500–999", min: 500, max: 999, cents: Math.round(baseCents * 0.85) },
        { quantity: "1,000–2,499", min: 1000, max: 2499, cents: Math.round(baseCents * 0.80) },
        { quantity: "2,500–4,999", min: 2500, max: 4999, cents: Math.round(baseCents * 0.75) },
        { quantity: "5,000–9,999", min: 5000, max: 9999, cents: Math.round(baseCents * 0.72) },
        { quantity: "10,000–24,999", min: 10000, max: 24999, cents: Math.round(baseCents * 0.70) },
        { quantity: "25,000+", min: 25000, max: null, cents: Math.round(baseCents * 0.65) }
      ]);
    }
    tiers.forEach(function (tier) {
      tier.currentCents = getVolumeBaseCents(
        baseCents + selectedAddonCents,
        tier.min
      );
    });
    var signature = JSON.stringify(tiers);

    function highlightCurrentTier() {
      var quantityInputs = Array.from(productInfo.querySelectorAll(
        "input[name='quantity'], input.quantity__input, [data-quantity-input]"
      ));
      var quantityInput = quantityInputs.find(function (input) {
        return input.type !== "hidden" && !input.disabled &&
          input.getClientRects().length > 0;
      }) || quantityInputs.find(function (input) {
        return input.type !== "hidden" && !input.disabled;
      }) || quantityInputs[0];
      var currentQuantity = quantityInput
        ? parseInt(quantityInput.value || quantityInput.getAttribute("value"), 10)
        : NaN;

      chart.querySelectorAll("[data-tier-min]").forEach(function (item) {
        var minimum = Number(item.dataset.tierMin);
        var maximum = item.dataset.tierMax === ""
          ? Infinity
          : Number(item.dataset.tierMax);
        var active = Number.isFinite(currentQuantity) &&
          currentQuantity >= minimum && currentQuantity <= maximum;
        item.classList.toggle("wgc-volume-pricing-active", active);
        if (active) {
          item.setAttribute("aria-current", "true");
        } else {
          item.removeAttribute("aria-current");
        }
      });
    }

    if (chart.dataset.wgcVolumeSignature === signature) {
      highlightCurrentTier();
      return;
    }

    while (chart.firstChild) chart.removeChild(chart.firstChild);

    var heading = document.createElement("div");
    heading.className = "wgc-volume-pricing-heading";
    var headingTitle = document.createElement("span");
    headingTitle.className = "wgc-volume-pricing-title";
    headingTitle.textContent = "Volume Pricing";
    var lowestCents = Math.min.apply(null, tiers.map(function (tier) {
      return tier.currentCents;
    }));
    var headingLow = document.createElement("span");
    headingLow.className = "wgc-volume-pricing-low";
    headingLow.textContent =
      "As low as " + currency + (lowestCents / 100).toFixed(2) + " ea.";
    heading.appendChild(headingTitle);
    heading.appendChild(headingLow);
    chart.appendChild(heading);

    function makePrice(tier) {
      var price = document.createElement("span");
      price.className = "wgc-volume-static-price";
      price.dataset.wgcPrice =
        currency + (tier.currentCents / 100).toFixed(2) + " ea.";
      price.textContent = price.dataset.wgcPrice;
      return price;
    }

    function setTierData(element, tier) {
      element.dataset.tierMin = String(tier.min);
      element.dataset.tierMax = tier.max === null ? "" : String(tier.max);
      if (tier.base) element.classList.add("wgc-volume-pricing-base");
    }

    var grid = document.createElement("div");
    grid.className = "wgc-volume-pricing-grid";
    grid.style.gridTemplateColumns =
      "minmax(38px, .65fr) repeat(" + tiers.length + ", minmax(0, 1fr))";
    var quantityHeading = document.createElement("div");
    quantityHeading.className = "wgc-volume-pricing-grid-label";
    quantityHeading.textContent = "QTY";
    grid.appendChild(quantityHeading);
    tiers.forEach(function (tier) {
      var cell = document.createElement("div");
      cell.className = "wgc-volume-pricing-grid-tier";
      cell.textContent = tier.quantity;
      setTierData(cell, tier);
      grid.appendChild(cell);
    });
    var eachHeading = document.createElement("div");
    eachHeading.className =
      "wgc-volume-pricing-grid-label wgc-volume-pricing-grid-each";
    eachHeading.textContent = "ea.";
    grid.appendChild(eachHeading);
    tiers.forEach(function (tier) {
      var cell = document.createElement("div");
      cell.className = "wgc-volume-pricing-grid-price";
      setTierData(cell, tier);
      cell.appendChild(makePrice(tier));
      grid.appendChild(cell);
    });
    chart.appendChild(grid);

    var mobile = document.createElement("div");
    mobile.className = "wgc-volume-pricing-mobile";
    var mobileHeading = document.createElement("div");
    mobileHeading.className = "wgc-volume-pricing-mobile-heading";
    var quantityLabel = document.createElement("span");
    quantityLabel.textContent = "Quantity";
    var priceLabel = document.createElement("span");
    priceLabel.textContent = "Price per cookie";
    mobileHeading.appendChild(quantityLabel);
    mobileHeading.appendChild(priceLabel);
    mobile.appendChild(mobileHeading);
    tiers.forEach(function (tier) {
      var row = document.createElement("div");
      row.className = "wgc-volume-pricing-mobile-row";
      setTierData(row, tier);
      var quantity = document.createElement("span");
      quantity.textContent = tier.quantity;
      row.appendChild(quantity);
      row.appendChild(makePrice(tier));
      mobile.appendChild(row);
    });
    chart.appendChild(mobile);
    chart.dataset.wgcVolumeSignature = signature;
    highlightCurrentTier();
  }

  function getVolumeBaseCents(baseCents, quantity) {
    if (!Number.isFinite(baseCents)) return NaN;
    if (!Number.isFinite(quantity) || quantity < 12) return baseCents;
    if (quantity <= 23) return baseCents + 150;
    if (!hasDiscountPricing || quantity <= 99) return baseCents;
    if (quantity <= 499) return Math.round(baseCents * 0.90);
    if (quantity <= 999) return Math.round(baseCents * 0.85);
    if (quantity <= 2499) return Math.round(baseCents * 0.80);
    if (quantity <= 4999) return Math.round(baseCents * 0.75);
    if (quantity <= 9999) return Math.round(baseCents * 0.72);
    if (quantity <= 24999) return Math.round(baseCents * 0.70);
    return Math.round(baseCents * 0.65);
  }

  function getVolumeDiscountRange(quantity) {
    if (!Number.isFinite(quantity) || quantity < 100) return "";
    if (quantity <= 499) return "100–499";
    if (quantity <= 999) return "500–999";
    if (quantity <= 2499) return "1,000–2,499";
    if (quantity <= 4999) return "2,500–4,999";
    if (quantity <= 9999) return "5,000–9,999";
    if (quantity <= 24999) return "10,000–24,999";
    return "25,000+";
  }

  function getVolumeRate(quantity) {
    if (!hasDiscountPricing || !Number.isFinite(quantity) || quantity < 100) {
      return 1;
    }
    if (quantity <= 499) return 0.90;
    if (quantity <= 999) return 0.85;
    if (quantity <= 2499) return 0.80;
    if (quantity <= 4999) return 0.75;
    if (quantity <= 9999) return 0.72;
    if (quantity <= 24999) return 0.70;
    return 0.65;
  }

  function getShopifyStyleLineTotalCents(regularUnitCents, quantity) {
    if (!Number.isFinite(regularUnitCents) ||
        !Number.isFinite(quantity) || quantity <= 0) {
      return NaN;
    }

    var adjustedUnitCents = quantity >= 12 && quantity <= 23
      ? regularUnitCents + 150
      : regularUnitCents;

    /* Shopify applies percentage pricing to the whole line, then rounds the
     * line total to cents. Rounding each cookie first creates discrepancies. */
    return Math.round(adjustedUnitCents * quantity * getVolumeRate(quantity));
  }

  function formatEffectiveUnitPrice(lineTotalCents, quantity, currency) {
    if (!Number.isFinite(lineTotalCents) ||
        !Number.isFinite(quantity) || quantity <= 0) {
      return "";
    }

    var amount = lineTotalCents / quantity / 100;
    var hundredths = amount * 100;
    var decimals = Math.abs(hundredths - Math.round(hundredths)) < 0.000001
      ? 2
      : 4;
    var formatted = amount.toFixed(decimals);

    if (decimals > 2) {
      formatted = formatted.replace(/0+$/, "");
      if (/\.\d$/.test(formatted)) formatted += "0";
    }

    return currency + formatted + " Each";
  }

  function updatePurchasePanel(productInfo, baseText, selectedAddonCents) {
    var buttons = productInfo.querySelector(".product-form__buttons");
    var quantityBlock = productInfo.querySelector(".product-form__quantity");
    var sourceChart = productInfo.querySelector(
      '.wgc-volume-pricing[data-wgc-chart="primary"]'
    );
    if (!buttons || !quantityBlock || !sourceChart) return;

    var panels = Array.from(productInfo.querySelectorAll(".wgc-purchase-panel"));
    var panel = panels.shift() || document.createElement("section");
    panels.forEach(function (duplicate) { duplicate.remove(); });
    panel.className = "wgc-purchase-panel";
    panel.setAttribute("aria-label", "Volume Pricing Breakdown");
    /* Do not reparent Shopify's quantity or product-form elements. Shopify and
     * LPO both update them, and moving them can cause visible rerender loops. */
    if (panel.contains(quantityBlock)) {
      panel.insertAdjacentElement("afterend", quantityBlock);
    }
    var productForm = buttons.closest("product-form");
    if (productForm && panel.contains(productForm)) {
      quantityBlock.insertAdjacentElement("afterend", productForm);
    }
    if (quantityBlock.previousElementSibling !== panel) {
      quantityBlock.insertAdjacentElement("beforebegin", panel);
    }

    var title = panel.querySelector(".wgc-purchase-panel-title");
    if (!title) {
      title = document.createElement("h2");
      title.className = "wgc-purchase-panel-title";
      title.textContent = "Volume Pricing Breakdown";
      panel.appendChild(title);
    }

    var chart = panel.querySelector(
      '.wgc-volume-pricing[data-wgc-chart="purchase"]'
    );
    if (!chart) {
      chart = document.createElement("section");
      chart.className = "wgc-volume-pricing";
      chart.dataset.wgcChart = "purchase";
      chart.setAttribute("aria-label", "Volume Pricing near quantity");
      title.insertAdjacentElement("afterend", chart);
    }
    if (chart.dataset.wgcVolumeSignature !== sourceChart.dataset.wgcVolumeSignature) {
      chart.replaceChildren.apply(chart, Array.from(sourceChart.childNodes).map(
        function (child) { return child.cloneNode(true); }
      ));
      chart.dataset.wgcVolumeSignature = sourceChart.dataset.wgcVolumeSignature;
    }
    var sourceTiers = sourceChart.querySelectorAll("[data-tier-min]");
    var purchaseTiers = chart.querySelectorAll("[data-tier-min]");
    purchaseTiers.forEach(function (tier, index) {
      var active = sourceTiers[index] && sourceTiers[index].classList.contains(
        "wgc-volume-pricing-active"
      );
      tier.classList.toggle("wgc-volume-pricing-active", !!active);
      if (active) tier.setAttribute("aria-current", "true");
      else tier.removeAttribute("aria-current");
    });

    var row = panel.querySelector(".wgc-purchase-panel-row");
    if (!row) {
      row = document.createElement("div");
      row.className = "wgc-purchase-panel-row";
      chart.insertAdjacentElement("afterend", row);
    }
    var price = row.querySelector(".wgc-purchase-panel-price");
    if (!price) {
      price = document.createElement("div");
      price.className = "wgc-purchase-panel-price";
      price.innerHTML = '<span>Your price</span><strong></strong>';
      row.appendChild(price);
    }
    var quantityInput = quantityBlock.querySelector("input[name='quantity']");
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : NaN;
    var baseCents = Math.round(parsePrice(baseText) * 100);
    var lineTotalCents = getShopifyStyleLineTotalCents(
      baseCents + selectedAddonCents, quantity
    );
    var minimumQuantity = isMinimumExemptVariant(productInfo) ? 2 : 12;
    var belowMinimum = Number.isFinite(quantity) &&
      quantity < minimumQuantity;
    var unitText = Number.isFinite(lineTotalCents) &&
      Number.isFinite(quantity) && quantity > 0 && !belowMinimum
      ? getCurrencyPrefix(baseText) +
        (Math.round(lineTotalCents / quantity) / 100).toFixed(2) + " Each"
      : "";
    var priceValue = price.querySelector("strong");
    var nextPrice = belowMinimum
      ? "Minimum quantity is " + minimumQuantity
      : (unitText || "Enter a quantity");
    price.classList.toggle("wgc-purchase-panel-price-error", belowMinimum);
    if (priceValue.textContent !== nextPrice) priceValue.textContent = nextPrice;

  }

  function placePriceSummaryAfterCart() {
    document.querySelectorAll(
      '.cl-po--option[data-option="Price Calculator"]'
    ).forEach(function (summaryField) {
      var productInfo = summaryField.closest(
        ".product__info-container, product-info, .product__info-wrapper"
      );
      var buttons = productInfo && productInfo.querySelector(
        ".product-form__buttons"
      );
      var summary = summaryField.querySelector(".cl-po--price-summary");

      if (!productInfo || !buttons || !summary) return;

      /* Keep LPO's calculator in its original container. Moving or cloning its
       * price markup lets LPO/Shopify mistake our display for a live price. */
      summaryField.classList.add("wgc-lpo-price-summary-source");

      var existingDisplays = Array.from(productInfo.querySelectorAll(
        ".wgc-lpo-price-summary-after-cart"
      ));
      var display = existingDisplays.shift() || null;

      /* Clean up duplicates created by earlier versions of this script. */
      existingDisplays.forEach(function (duplicate) {
        duplicate.remove();
      });

      if (!display) {
        display = document.createElement("div");
        display.className = "wgc-lpo-price-summary-after-cart";
      }
      if (buttons.nextElementSibling !== display) {
        buttons.insertAdjacentElement("afterend", display);
      }

      var quantityInput = productInfo.querySelector(
        "input[name='quantity'], input.quantity__input, [data-quantity-input]"
      );
      var quantity = quantityInput
        ? parseInt(quantityInput.value || quantityInput.getAttribute("value"), 10)
        : NaN;
      var baseText = getShopifyBasePrice(productInfo);
      var basePrice = parsePrice(baseText);
      var baseCents = Number.isFinite(basePrice)
        ? Math.round(basePrice * 100)
        : NaN;
      var currency = getCurrencyPrefix(baseText);
      var rows = Array.from(
        summary.querySelectorAll(".cl-po--price-summary-row")
      );
      var addonRows = rows.filter(function (row) {
        var text = normalize(row.textContent);
        return row.querySelector(".money") &&
          text.indexOf("base price") !== 0 &&
          !row.classList.contains("cl-po--price-summary-total") &&
          text.indexOf("total:") !== 0;
      }).map(function (row) {
        var money = row.querySelector(".money");
        var price = money ? (money.textContent || "").trim() : "";
        var labelNode = row.querySelector(
          ".cl-po--price-summary-label, .cl-po--price-summary-name"
        );
        var label = labelNode
          ? (labelNode.textContent || "").trim()
          : (row.textContent || "").replace(price, "").trim();
        return { label: label, price: price };
      });
      var classifiedAddonRows = addonRows.map(function (addon) {
        var addonLabel = normalize(addon.label).replace(/[–—]/g, "-");
        var addonKey = addonLabel.replace(/[\s_-]/g, "");
        var isVolumeSurcharge =
          addonKey === "quantitysurcharge" ||
          addonLabel.indexOf("quantity surcharge") !== -1 ||
          (addonLabel.indexOf("quantity") !== -1 &&
           addonLabel.indexOf("12-23") !== -1);
        var isVolumeDiscount = addonLabel.indexOf("discount") !== -1;

        return {
          label: addon.label,
          price: addon.price,
          kind: isVolumeSurcharge
            ? "surcharge"
            : (isVolumeDiscount ? "discount" : "addon")
        };
      });
      var selectedAddonCents = classifiedAddonRows.reduce(function (total, addon) {
        var addonPrice = parsePrice(addon.price);

        return addon.kind === "addon" && Number.isFinite(addonPrice)
          ? total + Math.round(addonPrice * 100)
          : total;
      }, 0);
      var displayAddonRows = classifiedAddonRows.filter(function (addon) {
        return addon.kind === "addon" ||
          (addon.kind === "surcharge" &&
           Number.isFinite(quantity) && quantity >= 12 && quantity <= 23);
      });
      var hasDisplayedSurcharge = displayAddonRows.some(function (addon) {
        return addon.kind === "surcharge";
      });
      if (Number.isFinite(quantity) && quantity >= 12 && quantity <= 23 &&
          !hasDisplayedSurcharge) {
        displayAddonRows.unshift({
          label: "Quantity (12–23)",
          price: currency + "1.50 Each",
          kind: "surcharge"
        });
      }
      var hasActiveVolumeDiscount =
        hasDiscountPricing && Number.isFinite(quantity) && quantity >= 100;
      if (hasActiveVolumeDiscount) {
        displayAddonRows.unshift({
          label: "Volume Discount",
          price: getVolumeDiscountRange(quantity),
          kind: "discount"
        });
      }
      var currentRegularCents = Number.isFinite(baseCents)
        ? baseCents + selectedAddonCents
        : NaN;
      var currentUnitCents = getVolumeBaseCents(
        currentRegularCents,
        quantity
      );
      var lineTotalCents = getShopifyStyleLineTotalCents(
        currentRegularCents,
        quantity
      );
      var currentUnitText = formatEffectiveUnitPrice(
        lineTotalCents,
        quantity,
        currency
      );
      var extendedTotal = Number.isFinite(lineTotalCents)
        ? currency + (lineTotalCents / 100).toFixed(2)
        : "";
      var calculation = Number.isFinite(quantity) && quantity > 0 && currentUnitText
        ? "(" + quantity + " × " + currentUnitText.toLowerCase() + ")"
        : "";
      var belowIndividualMinimum =
        isIndividualProduct &&
        !isMinimumExemptVariant(productInfo) &&
        Number.isFinite(quantity) &&
        quantity < 12;
      var signature = JSON.stringify({
        base: baseText,
        addons: displayAddonRows,
        calculation: calculation,
        total: extendedTotal,
        belowIndividualMinimum: belowIndividualMinimum
      });

      updateVolumePricingChart(
        productInfo,
        display,
        baseText,
        selectedAddonCents
      );
      updatePurchasePanel(productInfo, baseText, selectedAddonCents);

      if (display.dataset.wgcPriceSignature === signature) return;
      while (display.firstChild) display.removeChild(display.firstChild);

      function appendDisplayRow(label, value, className) {
        var row = document.createElement("div");
        row.className = "wgc-lpo-summary-row " + (className || "");
        var rowLabel = document.createElement("span");
        rowLabel.className = "wgc-lpo-summary-label";
        rowLabel.textContent = label;
        var rowValue = document.createElement("span");
        rowValue.className = "wgc-lpo-summary-value";
        rowValue.textContent = value;
        row.appendChild(rowLabel);
        row.appendChild(rowValue);
        display.appendChild(row);
        return rowValue;
      }

      var staticBaseValue = appendDisplayRow(
        "Base price:",
        "",
        "wgc-lpo-summary-base"
      );
      staticBaseValue.classList.add("wgc-lpo-static-base-value");
      staticBaseValue.dataset.wgcBasePrice = baseText || "";

      if (displayAddonRows.length) {
        var heading = document.createElement("div");
        heading.className = "wgc-lpo-summary-addons-heading";
        heading.textContent = "Add-ons:";
        display.appendChild(heading);
        displayAddonRows.forEach(function (addon) {
          appendDisplayRow(
            addon.label,
            addon.price,
            "wgc-lpo-summary-addon" +
              (addon.kind === "discount" ? " wgc-lpo-summary-discount" : "")
          );
        });
      }

      var totalValue = appendDisplayRow("Total:", "", "wgc-lpo-summary-total");
      if (belowIndividualMinimum) {
        totalValue.classList.add("wgc-lpo-minimum-total-value");
        var minimumMessage = document.createElement("span");
        minimumMessage.className = "wgc-lpo-minimum-total-message";
        minimumMessage.textContent = "Minimum quantity of this product is 12";
        totalValue.appendChild(minimumMessage);
        display.dataset.wgcPriceSignature = signature;
        return;
      }

      var calculationText = document.createElement("span");
      calculationText.className = "wgc-lpo-total-calculation";
      calculationText.textContent = calculation;
      var totalText = document.createElement("span");
      totalText.className = "wgc-lpo-extended-total";
      totalText.textContent = extendedTotal;
      totalValue.appendChild(calculationText);
      totalValue.appendChild(totalText);
      display.dataset.wgcPriceSignature = signature;
    });
  }

  function isCookieShape(field, label) {
    var dataOption = normalize(field.getAttribute("data-option")).replace(/^_+/, "");
    if (dataOption === "cookie shape") return true;
    var text = normalize(label && label.textContent).replace(/^_+/, "");
    return text === "cookie shape" || text.indexOf("cookie shape:") === 0;
  }

  function uniqueValues(nodes) {
    return Array.from(new Set(nodes.map(function (node) {
      return node.value;
    })));
  }

  function processCookieShape(field, label, radios, select) {
    if (!isCookieShape(field, label)) return;

    var availableRadios = Array.from(radios).filter(function (input) {
      return !input.disabled && input.value !== "";
    });
    var availableOptions = select ? Array.from(select.options).filter(function (option) {
      return !option.disabled && option.value !== "";
    }) : [];
    var radioValues = uniqueValues(availableRadios);
    var optionValues = uniqueValues(availableOptions);
    var hasOneChoice = (radioValues.length || optionValues.length) === 1;

    if (hasOneChoice && availableRadios.length) {
      var sourceRadio = availableRadios.find(function (input) {
        return !input.closest(".lpo-variant-override");
      }) || availableRadios[0];
      if (!sourceRadio.checked) sourceRadio.click();
    }

    if (hasOneChoice && select && optionValues.length === 1 &&
        select.value !== optionValues[0]) {
      select.value = optionValues[0];
      select.dispatchEvent(new Event("input", { bubbles: true }));
      select.dispatchEvent(new Event("change", { bubbles: true }));
    }

    field.classList.toggle("wgc-hide-single-cookie-shape", hasOneChoice);

    /* LPO and Shopify can inject later display rules, so enforce the result. */
    if (hasOneChoice) {
      field.style.setProperty("display", "none", "important");
    } else {
      field.style.removeProperty("display");
    }
  }

  function updateCookieShapes() {
    document.querySelectorAll(".cl-po--option").forEach(function (field) {
      processCookieShape(
        field,
        field.querySelector(":scope > .cl-po--label"),
        field.querySelectorAll(
          ".cl-po--swatch-container input.cl-po--input[type='radio']"
        ),
        field.querySelector("select.cl-po--input")
      );
    });

    document.querySelectorAll(
      "variant-selects .product-form__input, " +
      "variant-radios .product-form__input, " +
      "product-info .product-form__input"
    ).forEach(function (field) {
      processCookieShape(
        field,
        field.querySelector("legend.form__label, label.form__label"),
        field.querySelectorAll("input[type='radio']"),
        field.querySelector("select")
      );
    });
  }

  function updateDesignCustomization() {
    var checkbox = Array.from(document.querySelectorAll(
      '.cl-po--option input[type="checkbox"]'
    )).find(function (input) {
      var row = input.closest(".cl-po--checkbox-item");
      return normalize(input.value) === "add design customizations" ||
        normalize(row && row.textContent).indexOf("add design customizations") !== -1;
    });
    if (!checkbox) return;

    var row = checkbox.closest(".cl-po--checkbox-item");
    if (!row) return;

    row.classList.toggle(
      "wgc-show-design-customizations",
      allowDesignCustomizations
    );
    row.classList.toggle(
      "wgc-hide-design-customizations",
      !allowDesignCustomizations
    );
    row.style.setProperty(
      "display",
      allowDesignCustomizations ? "flex" : "none",
      "important"
    );

    var helper = row.querySelector(".wgc-design-customizations-note");
    if (allowDesignCustomizations && !helper) {
      helper = document.createElement("span");
      helper.className = "wgc-design-customizations-note";
      helper.textContent = "(may include more colors, clipart, etc.)";
      row.appendChild(helper);
    } else if (!allowDesignCustomizations && helper) {
      helper.remove();
    }

    if (!allowDesignCustomizations && checkbox.checked) checkbox.click();
  }

  function updateUploadChoice() {
    var checkbox = Array.from(document.querySelectorAll(
      '.cl-po--option input[type="checkbox"]'
    )).find(function (input) {
      var row = input.closest(".cl-po--checkbox-item");
      return normalize(input.value) === "add upload" ||
        normalize(row && row.textContent).indexOf("add upload") !== -1;
    });
    if (!checkbox) return;

    var row = checkbox.closest(".cl-po--checkbox-item");
    if (!row) return;

    row.classList.toggle("wgc-show-upload", showUpload);
    row.classList.toggle("wgc-hide-upload", !showUpload);

    if (!showUpload) {
      row.dataset.wgcUploadHidden = "true";
      row.style.setProperty("display", "none", "important");
      if (checkbox.checked) checkbox.click();
    } else {
      delete row.dataset.wgcUploadHidden;
      row.style.setProperty("display", "flex", "important");
    }
  }

  function reorderUploadField() {
    if (!moveUploadBeforeCustomizations) return;

    document.querySelectorAll(".cl-po--options").forEach(function (options) {
      var upload = Array.from(options.children).find(function (field) {
        return field.matches('.cl-po--option[data-option="Upload"]');
      });
      var customizations = Array.from(options.children).find(function (field) {
        return field.matches('.cl-po--option[data-option="Customizations"]');
      });

      if (!upload || !customizations || upload.nextElementSibling === customizations) {
        return;
      }

      options.insertBefore(upload, customizations);
      upload.classList.add("wgc-upload-before-customizations");
    });
  }

  function hideCartProperties() {
    document.querySelectorAll(
      ".cart-item dt, cart-drawer dt, .cart__meta dt, .product-details dt, .product-option dt"
    ).forEach(function (term) {
      var propertyName = (term.textContent || "")
        .replace(/:\s*$/, "")
        .trim()
        .toLowerCase();
      var comparablePropertyName = propertyName.replace(/^_+/, "");
      var shouldHide = HIDDEN_CART_PROPERTY_NAMES.some(function (name) {
        return comparablePropertyName === name.toLowerCase();
      });

      if (!shouldHide) return;

      var cartItem = term.closest(
        ".cart-item, [data-cart-item], [data-cart-item-key], .cart__row, .cart__item, .cart-item-row"
      );
      var quantityInput = cartItem && cartItem.querySelector(
        "input.quantity__input, input[name='updates[]'], input[name^='updates'], [data-quantity-input]"
      );
      var quantity = quantityInput
        ? parseInt(quantityInput.value || quantityInput.getAttribute("value"), 10)
        : NaN;

      /* Some cart templates render quantity as plain text instead of an input. */
      if (!Number.isFinite(quantity) && cartItem) {
        var quantityDisplay = cartItem.querySelector(
          "[data-cart-item-quantity], .cart-item__quantity-value, .cart-item__quantity, .cart__quantity, .cart__qty, [data-label='Quantity']"
        );
        var quantityText = quantityDisplay
          ? (quantityDisplay.textContent || "").trim()
          : "";
        var quantityMatch = quantityText.match(/(?:^|\s)(\d+)(?:\s|$)/);

        if (quantityMatch) quantity = parseInt(quantityMatch[1], 10);
      }

      if (!Number.isFinite(quantity) && cartItem) {
        quantity = parseInt(
          cartItem.getAttribute("data-quantity") ||
          cartItem.getAttribute("data-cart-item-quantity"),
          10
        );
      }
      var row = term.closest(
        ".product-option, [data-cart-item-property], .cart-item__property, li"
      ) || term.parentElement;

      if (row) {
        var cookieShapeTerms = cartItem
          ? Array.from(cartItem.querySelectorAll("dt")).filter(function (item) {
              return normalize(item.textContent)
                .replace(/:$/, "")
                .replace(/^_+/, "") === "cookie shape";
            })
          : [];
        var hideCookieShape =
          comparablePropertyName === "cookie shape" &&
          cookieShapeTerms.length > 1 &&
          cookieShapeTerms.indexOf(term) > 0;
        var hideQuantitySurcharge =
          (comparablePropertyName === "quantity surcharge" ||
           comparablePropertyName === "quantitysurcharge") &&
          Number.isFinite(quantity) &&
          quantity >= 24;

        row.classList.toggle(
          "wgc-hidden-cart-property",
          hideCookieShape || hideQuantitySurcharge
        );
      }
    });
  }

  function run() {
    sortFonts();
    updateVariantButtons();
    hideMinimumSelectors();
    updateMinimumQuantityExemption();
    styleTitleQualifiers();
    compactLabelValues();
    placePriceSummaryAfterCart();
    updateCookieShapes();
    updateDesignCustomization();
    updateUploadChoice();
    reorderUploadField();
    hideCartProperties();
  }

  var frameId = null;
  var settledTimerIds = [];
  function schedule() {
    if (frameId !== null) cancelAnimationFrame(frameId);
    frameId = requestAnimationFrame(function () {
      frameId = null;
      run();
    });
  }

  /* LPO finishes previews, variant IDs, and price calculations in separate
   * asynchronous steps. Refresh immediately, then briefly resync while those
   * app updates settle. This does not delay the customer's selection. */
  function scheduleSettled() {
    schedule();
    settledTimerIds.forEach(function (timerId) {
      clearTimeout(timerId);
    });
    settledTimerIds = [75, 200, 500].map(function (delay) {
      return setTimeout(schedule, delay);
    });
  }

  function rememberCustomerQuantity(event) {
    if (!event.isTrusted) return;
    var input = event.target;
    if (!input.matches || !input.matches(
      "input[name='quantity'], input.quantity__input, [data-quantity-input]"
    )) return;
    var productInfo = input.closest(
      ".product__info-container, product-info, .product__info-wrapper"
    );
    if (!productInfo || !productInfo.querySelector(
      '.cl-po--option[data-option="Price Calculator"], .wgc-volume-pricing'
    ) && !isIndividualProduct) return;
    customerQuantityChoice = input.value;
  }

  function handleQuantityButton(event) {
    if (!event.isTrusted ||
        !event.target.closest) return;
    var button = event.target.closest("quantity-input .quantity__button");
    var productInfo = button && button.closest(
      ".product__info-container, product-info, .product__info-wrapper"
    );
    if (!productInfo || (!isIndividualProduct && !productInfo.querySelector(
      '.cl-po--option[data-option="Price Calculator"], .wgc-volume-pricing'
    ))) return;
    var input = button.closest("quantity-input").querySelector(
      "input[name='quantity'], input.quantity__input"
    );
    if (!input || button.name !== "plus" && button.name !== "minus") return;

    /* The native theme handler can step a blank input inconsistently. Handle
     * only these product-page buttons and dispatch its normal change event. */
    event.preventDefault();
    event.stopImmediatePropagation();

    var minimum = isMinimumExemptVariant(productInfo) ? 2 : 12;
    var step = Number(input.step);
    if (!Number.isFinite(step) || step <= 0) step = 1;
    var maximum = input.max === "" ? Infinity : Number(input.max);
    var current = input.value.trim() === "" ? NaN : Number(input.value);
    var next;
    if (!Number.isFinite(current)) {
      if (button.name === "minus") return;
      next = minimum;
    } else {
      next = current + (button.name === "plus" ? step : -step);
      next = Math.max(minimum, Math.min(maximum, next));
    }
    if (String(next) === input.value) return;
    input.value = String(next);
    customerQuantityChoice = input.value;
    input.dispatchEvent(new Event("change", { bubbles: true }));
    scheduleSettled();
  }

  function preventInvalidQuantityAdd(event) {
    if (!event.target.closest) return;
    var action = event.type === "submit"
      ? event.target.closest("product-form form")
      : event.target.closest(
          '.product-form__submit, button[type="submit"][name="add"]'
        );
    if (!action) return;
    var productInfo = action.closest(
      ".product__info-container, product-info, .product__info-wrapper"
    );
    if (!productInfo || (!isIndividualProduct && !productInfo.querySelector(
      '.cl-po--option[data-option="Price Calculator"], .wgc-volume-pricing'
    ))) return;
    var input = productInfo && productInfo.querySelector(
      "input[name='quantity'], input.quantity__input, [data-quantity-input]"
    );
    if (!input || !input.hasAttribute("min")) return;
    var minimum = Number(input.getAttribute("min"));
    var quantity = Number(input.value);
    if (input.value.trim() && Number.isInteger(quantity) &&
        quantity >= minimum) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    input.reportValidity();
    input.focus();
  }

  function initialize() {
    run();
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });
    window.addEventListener("option:changed", scheduleSettled);
    document.addEventListener("variant:change", scheduleSettled, true);
    document.addEventListener("input", rememberCustomerQuantity, true);
    document.addEventListener("change", rememberCustomerQuantity, true);
    document.addEventListener("click", handleQuantityButton, true);
    document.addEventListener("click", preventInvalidQuantityAdd, true);
    document.addEventListener("submit", preventInvalidQuantityAdd, true);
    document.addEventListener("change", scheduleSettled, true);
    document.addEventListener("input", scheduleSettled, true);
    document.addEventListener("focusout", function (event) {
      if (event.target.matches && event.target.matches(
        "input[name='quantity'], input.quantity__input"
      )) schedule();
    }, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
